import { Box, Button, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { MainRoutePath } from 'library/Routes';

export interface IUnauthorizedScreen {
  label?: string,
  callback?: Function
  callbackLabel?: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',
      height: '100vh',
      padding: theme.spacing(),
      boxSizing: 'border-box'
    },
    label: {
      textAlign: 'center'
    },
    logoutButton: {
      textAlign: 'center',
      marginTop: '15px',
      alignSelf: 'center'
    }
  }),
);

export default ({label, callback, callbackLabel}: IUnauthorizedScreen) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={classes.loadingContainer}>
      <Typography className={ classes.label }>
        { label || t('UnauthorizedScreen.label') }
      </Typography>
      <Button
        className={classes.logoutButton}
        variant="contained"
        color="primary"
        onClick={ () => {
          if (typeof callback === 'function') {
            callback();
          } else {
            history.push(MainRoutePath);
          }
        } }>
        { callbackLabel || t('UnauthorizedScreen.callbackButton') }
      </Button>
    </Box>
  );
}